import { render } from "./ReviewDashboard.vue?vue&type=template&id=492cccfd"
import script from "./ReviewDashboard.vue?vue&type=script&lang=js"
export * from "./ReviewDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__